"use strict";
import VendorContainer from 'emun.vendor/vendor-container'
import VendorGroupContainer from 'emun.vendor/vendorgroup-container'
import VendorList from 'emun.vendor/vendor-list'
import VendorGroupList from 'emun.vendor/vendorgroup-list'
import VendorDashboard from 'emun.vendor/vendor-dashboard'
import VendorGroupDashboard from 'emun.vendor/vendorgroup-dashboard'
import VendorDashboardToolbar from 'emun.vendor/vendor-dashboard-toolbar'
import VendorDashboardHeader from 'emun.vendor/vendor-dashboard-header'
import VendorGroupDashboardToolbar from 'emun.vendor/vendorgroup-dashboard-toolbar'
import VendorGroupDashboardHeader from 'emun.vendor/vendorgroup-dashboard-header'
import VendorFiles from 'emun.vendor/vendor-files'
import custom from 'emun.vendor/_emun.custom'
import VendorContacts from 'emun.vendor/vendor-contacts'
import VendorUsers from 'emun.vendor/vendor-users'
import VendorContactPrompt from 'emun.vendor/vendor-contact-prompt'
import VendorContactPopover from 'emun.vendor/vendor-contact.popover.htm'
import VendorContactPromptDirective from 'emun.vendor/vendor-contact-prompt-directive'
import VendorDocuments from 'emun.vendor/documents/vendor-documents'
import VendorConnections from 'emun.vendor/vendor-connections'
import VendorApiKey from 'emun.vendor/vendor-api-key'
import VendorAppConnection from 'emun.vendor/vendor-app-connection'
import VendorPaymentgatewayCredentials from 'emun.vendor/vendor-paymentgateway-credentials'
import VendorFileImport from 'emun.vendor/file-import/vendor-file-import'
import AWSS3Objects from 'emun.vendor/file-import/aws-s3-objects'
import StripeRefresh from 'emun.vendor/stripe/stripe-refresh'
import StripeReturn from 'emun.vendor/stripe/stripe-return'
import StripeConnected from 'emun.vendor/stripe/stripe-connected'
import AgencySelector from 'emun.vendor/agency-selector'

const deps = [
    'emun.auth',
    'webutils',
    'webforms',
    'webmodals',
    'ui.router'];

let mod = angular.module('emun.vendor', deps)
	.component('vendorContainer', VendorContainer)
	.component('vendorgroupContainer', VendorGroupContainer)
	.component('vendorList', VendorList)
	.component('vendorgroupList', VendorGroupList)
	.component('vendorDashboard', VendorDashboard)
	.component('vendorgroupDashboard', VendorGroupDashboard)
	.component('vendorFiles', VendorFiles)
	.component('vendorDashboardToolbar', VendorDashboardToolbar)
	.component('vendorgroupDashboardToolbar', VendorGroupDashboardToolbar)
	.component('vendorContacts', VendorContacts)
	.component('vendorUsers', VendorUsers)
	.directive('vendorContactPrompt', VendorContactPromptDirective)
	.component('vendorDashboardHeader', VendorDashboardHeader)
	.component('vendorDocuments', VendorDocuments)
	.component('vendorConnections', VendorConnections)
	.component('vendorApiKey', VendorApiKey)
	.component('vendorAppConnection', VendorAppConnection)
	.component('stripeRefresh', StripeRefresh)
	.component('stripeReturn', StripeReturn)
	.component('stripeConnected', StripeConnected)
	.component('agencySelector', AgencySelector)
	.component('vendorPaymentgatewayCredentials', VendorPaymentgatewayCredentials)
	.component('vendorgroupDashboardHeader', VendorGroupDashboardHeader)
	.component('vendorFileImport', VendorFileImport)
	.component('awsS3Objects', AWSS3Objects);




custom(mod);

export default mod.name;

